import { createSelector } from "@ngrx/store";
import { IEmployeeReportState } from "./employee-report.reducer";

const employeeReportStore = (state: any) => state.employeeReport as IEmployeeReportState

export const selectEmployeeReport = createSelector(
    employeeReportStore,
    (state) => state.employee_report
)